(function () {
    'use strict';

    angular.module('swif.interventions')
        .service('taskService', taskService);

    function taskService($q, swif, swifInterventionsConstant, swifAchatsService, swifOpenbaseCompanyService) {
        'ngInject';

        var service = {};
        service.currentCollection = {};
        service = swifInterventionsConstant.task;
        service.COLLECTION_FIELDS = [
            'absent_type_id',
            'actions',
            'agent_or_team_name',
            'cancel_reason',
            'category_id',
            'child_ids',
            'color',
            'company_id',
            'consumable_asks',
            'consumable_request_id',
            'consumable_request_ids',
            'consumable_request_state',
            'consumable_ids',
            'consumable_names',
            'consumable_swif_id',
            'consumable_ask_note',
            'consumable_ask_date_delivery',
            'purchase_order_ask_ids',
            'purchase_order_ask_fields',
            'purchase_order_ids',
            'purchase_order_fields',
            'date_deadline',
            'date_start',
            'date_end',
            'equipment_id',
            'delay_hours',
            'delegated_user_id',
            'effective_controls',
            'effective_hours',
            'equipment_names',
            'id',
            'swif_id',
            'ask_id',
            'create_date',
            'create_uid',
            'inter_desc',
            'inter_equipment',
            'intervention_assignement_id',
            'kanban_state',
            'km',
            'kronos_id',
            'manager_id',
            'msexchange_id',
            'name',
            'notes',
            'oil_price',
            'oil_qtity',
            'parent_id',
            'parent_ids',
            'partner_id',
            'partner_address',
            'notify',
            'patrimoine_is_equipment',
            'planned_hours',
            'priority',
            'progress',
            'project_id',
            'can_read_project',
            'recurrence',
            'remaining_hours',
            'schedule_deadline',
            'schedule_delay',
            'schedule_delay_passed',
            'schedule_remaining_delay',
            'sequence',
            'service_id',
            'site1',
            'site_category',
            'site_control_ids',
            'site_details',
            'site_ids',
            'site_names',
            'state',
            'team_id',
            'total_hours',
            'type_id',
            'user_email',
            'user_id',
            'cost',
            'hr_cost',
            'equipment_cost',
            'consumable_cost',
            'equipment_ids',
            'equipment_movement_type',
            'attachment_count',
            'mail_message_count',
            'sms_message_count',
            'external',
            'recurrence_id',
            'description',
            'work_ids',
            'geo_point',
            'has_site_on_task_feature'
        ];
        service.PROJECT_ID_FIELDS = ['id', 'service_id', 'name', 'project_type'];

        service.resolveData = function (options, type) {
            return swif.route.check(options).then(function () {
                var deferred = $q.defer();
                var data = {};
                data.debug = swif.route.debug;
                data.title = 'Tasks';
                service.createCollection(type).then(function (collection) {
                    data.tasks = collection;
                    service.currentCollection = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };

        service.getCountFilter = function () {
            var user = swif.user.getAuthenticatedUser();
            var countFilter = {
                info: {}
            };
            swif.data.addFilter(countFilter.info, '|');
            swif.data.addFilter(
                countFilter.info,
                'user_id', 'in', [user.uid]
            );
            swif.data.addFilter(
                countFilter.info,
                'team_id.user_ids', 'in', [user.uid]
            );
            swif.data.addFilter(
                countFilter.info,
                'state', 'in', ['draft', 'open']
            );
            countFilter.info.fields = swif.module.hasModule('opengst_hospital_connector') ?
            [...service.COLLECTION_FIELDS, 'customer_partner_address', 'customer_partner_id']
            : service.COLLECTION_FIELDS;
            return countFilter;
        };

        service.fetchTaskVehicle = function(model) {
            var vFilter = {};
            swif.data.addFilter(vFilter, 'task_id', '=', model.id);
            swif.data.get('equipment_line', undefined, vFilter).then(function (vData) {
                if (!_.isEmpty(vData)) {
                    var vehicle = vData[0].equipment_id || false;
                    if (vehicle) {
                        _.remove(model.equipment_ids, vehicle[0]);
                        model.vehicule = vehicle;
                        model.km = vData[0].km || 0;
                        model.oil_qtity = vData[0].oil_qtity || 0;
                        model.oil_price = vData[0].oil_price || 0;
                    }
                }
            });
        }

        service.fetchReport = function (model) {
            var wFilter = {fields: ['hours']};
            swif.data.sortOn(wFilter, 'id');
            swif.data.addFilter(wFilter, 'task_id', '=', model.id);
            swif.data.get('work', undefined, wFilter).then(function (wData) {
                if (!_.isEmpty(wData)) {
                    model.report_hours = wData[0].hours;
                }
            });

            var cFilter = {fields: ['dqe', 'quantity', 'unit_price', 'consumable_id', 'supplier_id', 'purchase_order_name', 'work_id']};
            swif.data.addFilter(cFilter, 'work_id.task_id', '=', model.id);
            swif.data.get('consumed', undefined, cFilter).then(function (cData) {
                if (!_.isEmpty(cData)) {
                    cData[0].new = false;
                    cData.map(consumed => consumed .addedManuallyByUser = false);
                }
                let consuFilter = {fields : ['product_id']};
                let consumables_ids = [];
                angular.forEach(cData, (consu) => {
                    consumables_ids.push(consu.consumable_id[0]);
                });
                swif.data.addFilter(consuFilter, 'id', 'in', consumables_ids);
                // TG4087 - remove askedConsumables from consumed consumables
                // cause we add them later
                swif.data.get('consumable', undefined, consuFilter).then(function (consumables) {
                    var foundAskedConsumables = [];
                    model.consumables = cData.filter(consumed =>
                        {
                            if (foundAskedConsumables.find(match => match === consumed.consumable_id[0])) {
                                return consumables;
                            } else {
                                return !model.consumable_asks.some(cAsked =>
                                    {
                                        var conso = consumables.find(c => c.id === consumed.consumable_id[0]);
                                        var askedConsumableFound = cAsked.product_id[0] == conso.product_id[0] && cAsked.product_qty === consumed.quantity;
                                        // Remove askedConsumable just once
                                        if (askedConsumableFound) {
                                            foundAskedConsumables.push(consumed.consumable_id[0]);
                                        }
                                        return askedConsumableFound;
                                    }
                                )
                            }
                        }

                    )
                });
            });
            service.fetchTaskVehicle(model);
        };

        service.preparePurchaseOrderAsk = function (model) {
            var PO_ask_id = model.purchase_order_ask_fields.id;
            model.purchase_order_ask_fields.order_lines = swif.data.prepareOne2manyValues(
                model.purchase_order_ask_fields.order_lines || [],
                model.purchase_order_ask_fields.products,
                function (line) {
                    var ret = {};
                    ret.description = line.dqe;
                    ret.product_id = line.product_id[0];
                    ret.qty = line.qty || 0.0;
                    return ret;
                }
            );
            model.purchase_order_ask_ids = [[
                PO_ask_id ? 1: 0,
                PO_ask_id || 0,
                {
                    name: model.name,
                    service_id: model.service_id ? model.service_id[0]: false,
                    order_lines: model.purchase_order_ask_fields.order_lines
                }
            ]];
        }

        service.preparePurchaseOrder = function (model) {
            var PO_Id = model.purchase_order_fields.id;
            model.purchase_order_fields.order_line = swif.data.prepareOne2manyValues(
                model.purchase_order_fields.order_line || [],
                model.purchase_order_fields.lines,
                function (line) {
                    var ret = {};
                    ret.name = line.name;
                    ret.product_id = line.product_id[0];
                    ret.taxes_id = [[6, 0, line._tax ? [line._tax[0]]: [] ]];
                    ret.product_qty = line.product_qty || 0.0;
                    ret.price_unit = line.price_unit;
                    return ret;
                }
            );
            // TODO : récupérer le chef de service
            var userId = model.user_id ? model.user_id[0]: false;
            var currentuserId = swif.user.getAuthenticatedUserData().id;
            model.purchase_order_ids = [[
                PO_Id ? 1: 0,
                PO_Id || 0,
                {
                    description: model.name,
                    warehouse_id: model.purchase_order_fields.warehouse_id[0],
                    account_analytic_id: model.purchase_order_fields.account_analytic_id[0],
                    service_id: model.service_id ? model.service_id[0]: false,
                    user_id: userId || currentuserId,
                    order_line: model.purchase_order_fields.order_line,
                    partner_id: model.purchase_order_fields.partner_id[0]
                }
            ]];
        }

        // computes 'consumable_request_ids' field value
        // CAREFUL: headache incoming: consumable_asks is function field
        //          linking to consumable_request_id's value,
        //          it's not a one2many of the task, but of the consumable request
        service.prepareConsumableRequest = function (model) {
            console.log('here', model);
            var reqId = model.consumable_request_id;
            // prepare consumable_ask_ids values
            var consumable_ask_ids = swif.data.prepareOne2manyValues(
                model.consumable_ask_ids || [],
                model.consumable_asks || [],
                function (elt) {
                    return {
                        product_id: elt.product_id ? elt.product_id[0] : false,
                        product_qty: elt.product_qty || 0,
                        service_id: model.service_id ? model.service_id[0] : false
                    };
                });
            // manually compute one2many values (i update / create ONLY current request)
            // i don't the other requests ('cancelled', etc...) to be removed by prepareOne2manyValues
            var userId = model.user_id ? model.user_id[0]: false;
            var currentuserId = swif.user.getAuthenticatedUserData().id;
            model.consumable_request_ids = [[
                reqId ? 1: 0,
                reqId || 0,
                {
                    name: model.name || '',
                    service_id: model.service_id ? model.service_id[0]: false,
                    user_id: userId || currentuserId,
                    site_id: model.site1 ? model.site1[0]: false,  // really used ?
                    merge_line_ask_id: consumable_ask_ids,
                    date_delivery: model.consumable_ask_date_delivery ? model.consumable_ask_date_delivery : false,
                    note: model.consumable_ask_note
                }
            ]];
        };

        service.createEquipmentMovementLines = function (vals, fields) {
            return swif.data.create('equipment_movement_line', vals, undefined, fields)
                .then(function (data) {
                    return data;
                });
        }

        service.saveEquipmentMovementLines = function (model) {
            var movementLinesFields = [
                'move_date',
                'type',
                'site_id',
                'external_holder',
                'equipment_ids',
                'holder_contact',
                'holder_partner',
                'holder_department',
                'holder_name',
                'holder_phone',
            ];
            var newModel = {};
            newModel.move_date = model.date_start;
            newModel.type = model.equipment_movement_type === 'comeBack' ? 'come_back' : model.equipment_movement_type;
            newModel.external_holder = false;
            newModel.holder_name = null;
            newModel.holder_phone = null;
            newModel.site_id = model.site1;
            newModel.equipment_ids = model.equipment_ids;
            newModel.holder_contact = model.user_id ? model.user_address_id : null;
            newModel.holder_partner = model.partner_id ? model.partner_id : null;
            newModel.holder_department = model.team_id ? model.service_id : null;
            // Override the holder_contact if user can set a customer by `About the customer` tab in the done modal !
            if (model.customer_partner_address) {
                newModel.holder_contact = model.customer_partner_address;
            }
            return service.createEquipmentMovementLines(newModel, movementLinesFields);
        }

        /**
         * @return boolean
         */
        service.preValidate = function (data) {
            var validated = swif.collections.preValidate(data);
            let user = swif.user.getAuthenticatedUserData();
            let access_rights = swif.user.getAccessRights();
            let addPendingTaskFields = [
                'name',
                'category_id',
                'equipment_id',
                'equipment_ids',
                'vehicule',
                'project_id',
                'service_id',
                'user_id',
                'team_id',
                'partner_id',
                'partner_address',
                'notify',
                'date_start',
                'date_end',
                'site1',
                'site_details',
                'planned_hours',
                'description',
                'geo_point',
                'has_site_on_task_feature'
             ];

            let addPendingTaskFieldsDomecco = [
                'consumable_request_ids',
                'purchase_order_ask_ids',
                'purchase_order_ids'
            ];

            let addDoneTaskFields = [
                'name',
                'category_id',
                'project_id',
                'service_id',
                'user_id',
                'team_id',
                'partner_id',
                'partner_address',
                'notify',
                'date_start',
                'date_end',
                'consumables',
                'recurrence',
                'equipment_id',
                'equipment_ids',
                'km',
                'oil_price',
                'oil_qtity',
                'remaining_hours',
                'report_hours',
                'site1',
                'site_details',
                'vehicule',
                'description',
                'geo_point',
                'has_site_on_task_feature'
            ];

            let saveTaskFields = [
                'absent_type_id',
                'actions',
                'active',
                'agent_or_team_name',
                'ask_id',
                'attachment_count',
                'can_read_project',
                'cancel_reason',
                'category_id',
                'child_ids',
                'color',
                'company_id',
                'consumable_ask_ids',
                'consumable_asks',
                'consumable_cost',
                'consumable_ids',
                'consumable_names',
                'consumable_request_id',
                'consumable_request_ids',
                'purchase_order_ask_fields',
                'purchase_order_fields',
                'purchase_order_ask_ids',
                'purchase_order_ids',
                'cost',
                'create_date',
                'date_deadline',
                'date_end',
                'date_start',
                'delay_hours',
                'delegated_user_id',
                'description',
                'effective_controls',
                'effective_hours',
                'equipment_cost',
                'equipment_id',
                'equipment_ids',
                'equipment_names',
                'external',
                'geo_point',
                'hr_cost',
                'id',
                'inter_desc',
                'inter_equipment',
                'intervention_assignement_id',
                'kanban_state',
                'km',
                'kronos_id',
                'mail_message_count',
                'manager_id',
                'msexchange_id',
                'name',
                'notes',
                'oil_price',
                'oil_qtity',
                'parent_id',
                'parent_ids',
                'partner_id',
                'partner_address',
                'notify',
                'patrimoine_is_equipment',
                'planned_hours',
                'priority',
                'progress',
                'project_id',
                'recurrence_id',
                'recurrence',
                'remaining_hours',
                'schedule_deadline',
                'schedule_delay',
                'schedule_delay_passed',
                'schedule_remaining_delay',
                'sequence',
                'service_id',
                'site1',
                'site_control_ids',
                'site_details',
                'site_ids',
                'site_names',
                'state',
                'swif_id',
                'team_id',
                'total_hours',
                'type_id',
                'user_id',
                'vehicule',
                'work_ids',
                'has_site_on_task_feature'
            ];
            if (swif.module.hasModule('opengst_hospital_connector')) {
                let customerFields = ['customer_partner_address', 'customer_partner_id'];
                addPendingTaskFields = [...addPendingTaskFields, ...customerFields];
                addDoneTaskFields = [...addDoneTaskFields, ...customerFields];
                saveTaskFields = [...saveTaskFields, ...customerFields];
            }

            // Format consumables
            _.forEach(data.model.consumables, function (line) {
                if(line.supplier_id && !_.isEmpty(line.supplier_id)) {
                    line.supplier_id = line.supplier_id[0];
                }
                if(line.consumable_id && !_.isEmpty(line.consumable_id)) {
                    line.consumable_id = line.consumable_id[0];
                }
            });

            if (data.action.id === 'notdone') {
                data.model.user_id = false;
                data.model.team_id = false;
                data.model.date_start = false;
                data.model.date_end = false;
                data.model.partner_id = false;
                data.model.partner_address = false;
                data.model.state = 'draft';
            }

            // send a flag to task model to know whether the feature is activated or not
            var siteOnTaskFeature = swif.settings.app.features.siteOnTask;
            if (siteOnTaskFeature) {
                data.model.has_site_on_task_feature = siteOnTaskFeature;
                // Task's equipment in case of siteontask don't depend on inter
                delete data.model['inter_equipment']
            }
            // No inter_equipment in case of orphan task
            if (!data.model.inter_desc){
                delete data.model['inter_equipment']
            }
            var domeccoActivated = swif.settings.app.features.domeccoActivated;
            if (data.action.id === 'add' || data.action.id === 'assign_multi' ) {
                if (data.model.state === 'done') {
                    data.action.http.fields = addDoneTaskFields;
                    // Create equipment movement lines
                    if (swif.settings.app.features.equipmentMovement && access_rights.openstc_patrimoine_equipment_movement_menu && user.can_manage_equipment_move && !_.isEmpty(data.model.equipment_ids)) {
                        data.action.http.fields.push('equipment_movement_type');
                        data.model.equipment_movement_type = data.model.equipment_movement_type === 'comeBack' ? 'come_back' : data.model.equipment_movement_type;
                        service.saveEquipmentMovementLines(data.model);
                    }
                }
                if (data.model.state === 'open' || data.model.state === 'draft') {
                    setPendingTaskFields(data, domeccoActivated)
                }
                if (swif.module.modules.openstc_achat_stock){
                    if (data.model.consumable_asks && data.model.consumable_asks.length > 0) {
                        service.prepareConsumableRequest(data.model);
                        if (!_.isEmpty(data.action.http.fields)) {
                            data.action.http.fields.push('consumable_request_ids');
                        }
                    }

                    // Create consumable move lines
                    swifAchatsService.consumable_stock.createConsumableMoveLines(data);
                }
            }
            if (data.action.id === 'copy') {
                setPendingTaskFields(data, domeccoActivated)
            }

            if (data.action.id === 'edit') {
                // Force send vehicule field
                data.action.http['fields'] = saveTaskFields;
                if (data.model.vehicule) {
                    data.model.vehicule = data.model.vehicule[0];
                }
                if (swif.module.modules.openstc_achat_stock){
                    if (data.model.consumable_asks && data.model.consumable_asks.length > 0) {
                        service.prepareConsumableRequest(data.model);
                    }
                }
            }
            if (data.action.id === 'router_edit') {
                //we find the next action and dispatch it
                let actionId = data.action.id.replace('router_', '');
                var action = swif.action.getActionById(
                    data.model._type,
                    'primary',
                    actionId,
                    data.model,
                    true
                );
                var options = {
                    preModal: service.preModal,
                    preValidate: service.preValidate,
                    callback: service.callback
                };
                swif.action.dispatch(
                    'task',
                    action,
                    data.model,
                    options
                );
            }
            if (data.action.id === 'edit' && data.model.recurrence_id) {
                //user want to save a recurrent task
                data.action.http.fields = saveTaskFields;
            }
            if (data.action.id === 'router_delete'){
                if (data.model.recurrence.recurrenceChoice!='onlyThisTask'){
                    //user want to delete a list of tasks
                    // tasks ids are in data.model.ids and data.model.id is used by default
                    delete data.model.id;
                }
            }
            const normalizeDatetime = (obj, operationType=undefined, time=undefined) => {
                let nativeDatetime;
                if (obj._isAMomentObject) {
                    if (operationType === 'add') {
                        nativeDatetime = new Date(obj.add(time, 'h').format());
                    } else if (operationType === 'sub') {
                        nativeDatetime = new Date(obj.subtract(time, 'h').format());
                    } else {
                        nativeDatetime = new Date(obj.format());
                    }
                } else {
                    let momentObj = moment.utc(obj);
                    if (operationType === 'add') {
                        momentObj = momentObj.add(time, 'h');
                        nativeDatetime = new Date(momentObj._d);
                    } else if (operationType === 'sub') {
                        momentObj = momentObj.subtract(time, 'h');
                        nativeDatetime = new Date(momentObj._d);
                    } else {
                        nativeDatetime = new Date(momentObj._d);
                    }
                }
                return nativeDatetime;
            }
            if (data.action.id === 'done') {
                //split on team members
                if(data.model._tasks && data.model.team_id) {
                    data.model.team_id = false;
                    data.model.user_id = data.model._tasks[0].user_id;
                    data.model.report_hours = data.model._tasks[0].report_hours;
                    data.model.date_start = normalizeDatetime(data.model._tasks[0].date_start);
                    data.model.date_end = normalizeDatetime(data.model._tasks[0].date_start, 'add', data.model._tasks[0].report_hours);
                    data.model._tasks.shift(); //remove first task because it is the data.model;
                    data.model._tasks.forEach((task) => {
                        task.user_id = task.user_id[0]; //sanitize
                        task.date_start = normalizeDatetime(task.date_start);
                        task.date_end = normalizeDatetime(task.date_start, 'add', task.report_hours);
                        task.name = data.model.name;
                    });
                }
                if (data.model.vehicule) {
                    data.model.vehicule = data.model.vehicule[0];
                }
                delete data.model.remaining_hours;

                // Create consumable move lines
                if (swif.module.modules.openstc_achat_stock){
                    swifAchatsService.consumable_stock.createConsumableMoveLines(data);
                }

                if (data.model._templates) {
                    // Format assigned people and set date_end properly to report_hours
                    data.model._templates.map(tmpl => {
                        tmpl.date_end = moment(tmpl.date_start).add(tmpl.report_hours, 'h').format('YYYY-MM-DD HH:mm:ss');
                        tmpl.user_id = tmpl.user_id ? tmpl.user_id[0] : false;
                        tmpl.team_id = tmpl.team_id ? tmpl.team_id[0] : false;
                        tmpl.partner_id = tmpl.partner_id ? tmpl.partner_id[0] : false;
                        tmpl.partner_address = tmpl.partner_address ? tmpl.partner_address[0] : false;
                    })
                }

                // Create equipment movement lines
                if (swif.settings.app.features.equipmentMovement && access_rights.openstc_patrimoine_equipment_movement_menu && user.can_manage_equipment_move && !_.isEmpty(data.model.equipment_ids)) {
                    data.action.http.fields.push('equipment_movement_type');
                    data.model.equipment_movement_type = data.model.equipment_movement_type === 'comeBack' ? 'come_back' : data.model.equipment_movement_type;
                    service.saveEquipmentMovementLines(data.model);
                }

            }
            if (data.action.id === 'notfinished') {
                //split on team members
                if(data.model._tasks && data.model.team_id) {
                    data.model._tasks.forEach((task) => {
                        task.user_id = task.user_id[0]; //sanitize
                        task.date_start = data.model.date_start
                        task.date_end = moment(task.date_start, 'YYYY-MM-DD HH:mm:ss').add(task.report_hours, 'h').format('YYYY-MM-DD HH:mm:ss');
                        task.name = data.model.name;
                    });
                    //unschedule original task for the team.
                    data.model.report_hours = false;
                    data.model.date_start = false;
                    data.model.date_end = false;
                    data.model.planned_hours = data.model.remaining_hours;
                }
            }
            if (swif.module.modules.openstc_achat_stock){
                if (_.contains(['add', 'copy'], data.action.id)) {
                    if (data.model.consumable_asks && data.model.consumable_asks.length > 0) {
                        service.prepareConsumableRequest(data.model);
                    }
                    // Create consumable move lines
                    swifAchatsService.consumable_stock.createConsumableMoveLines(data);

                    if (data.model.purchase_order_fields && data.model.purchase_order_fields.lines && data.model.purchase_order_fields.lines.length > 0) {
                        service.preparePurchaseOrder(data.model);
                    }
                    if (data.model.purchase_order_ask_fields && data.model.purchase_order_ask_fields.products && data.model.purchase_order_ask_fields.products.length > 0) {
                        service.preparePurchaseOrderAsk(data.model);
                    }
                }
            }
            if (data.model.original_project_id != false && data.model.can_read_project === false && data.action.id == "edit") {
                delete data.model.project_id;
                delete data.model.manager_id;
                delete data.model.inter_desc;
            }

            if (Array.isArray(data.model.user_id) && Number.isInteger(data.model.user_id[1])) {
                // Duplicate task with main attribute when multiple user_ids
                var user_ids = data.model.user_id;
                data.model.user_id = [user_ids.shift(), ''];
                data.model._multiple = [];
                for (const id of user_ids) {
                    var task = angular.copy(data.model);
                    task.user_id =  [id, ''];
                    // Remove useless attributes for secondary tasks
                    delete task.consumable_request_ids
                    delete task.consumable_asks
                    delete task.consumables
                    delete task.vehicule
                    delete task.equipment_ids
                    delete task.purchase_order
                    delete task.oil_price
                    delete task.oil_qtity
                    delete task.km
                    data.model._multiple.push(task);
                }
            }
            if (data.model.planning) {
                data.model = service.fillPlanningTask(data.model)
            }

            return validated;

            function setPendingTaskFields(data, domeccoActivated){
                  if (domeccoActivated === true) {
                      data.action.http.fields = addPendingTaskFields.concat(addPendingTaskFieldsDomecco);
                  } else {
                      data.action.http.fields = addPendingTaskFields;
                  }
                  if (data.model.recurrence
                      && data.model.recurrence['recurrenceChoice'] !== 'onlyThisTask'
                      && typeof data.model.recurrence['recurrence'] !== 'undefined') {
                      data.action.http.fields.push('recurrence')
                  }
            }
        };

        service.fillPlanningTask = function(model) {
            var initialTaskEdited = false;
            // Save original date_start and date_end for fillInRange usage
            moment.locale('fr');
            if (!model.range_start) {
                model.range_start = model.date_start.local();
                model.range_end = moment(model.date_end).local()
                if (model.range_end.isDST()) { // Is Daylight time
                    model.range_end = model.range_end.add(2, 'hours')
                } else {
                    model.range_end = model.range_end.add(1, 'hours')
                };
            }

            if (!Array.isArray(model._multiple)) {
                model._multiple = [];
            }

            for (const ts of model.planning.time_slots) {
                var task = angular.copy(model);
                var date_start = task.date_start; // Taking current week selected on calendar
                var date_end = date_start.clone();

                date_start.weekday(ts.day_start).hour(ts.range_start).minute((ts.range_start % 1) * 60);
                date_end.weekday(ts.day_end).hour(ts.range_end).minute((ts.range_end % 1) * 60);
                if (model.fillInRange) {
                    // If strictly out of range
                    if (date_start >= model.range_end || date_end <= model.range_start) {
                        continue;
                    }

                    // If partially out of range, crop date
                    if (date_end > model.range_end) {
                        date_end = model.range_end
                    }
                    if (date_start < model.range_start) {
                        date_start = model.range_start
                    }
                }
                var planned_hours = moment.duration(date_end - date_start).asMinutes() / 60

                if (!initialTaskEdited){
                    model.date_start = date_start
                    model.date_end = date_end
                    model.planned_hours = planned_hours
                    initialTaskEdited = true
                } else {
                    task.date_start = date_start
                    task.date_end = date_end
                    task.planned_hours = planned_hours
                    model._multiple.push(task);
                }
            }
            return model
        }

        service._preModal = function (data) {
            if (data.action.id === 'add') {
                if (data.model._type === 'intervention') {
                    if (swif.module.hasModule('opengst_hospital_connector')) {
                        data.model = {
                            swif_id: data.model.swif_id,
                            _type: data._type,
                            ask_id: data.model.ask_id,
                            project_id: [data.model.id, data.model.name],
                            name: data.model.name,
                            service_id: data.model.service_id,
                            customer_partner_address: data.model.customer_partner_address,
                            customer_partner_id: data.model.customer_partner_id
                        };
                    } else {
                        data.model = {
                            project_id: [data.model.id, data.model.name],
                            name: data.model.name,
                            service_id: data.model.service_id
                        };
                    }
                    swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                        data.model.planned_hours= company.task_default_hours;
                        data.model.notify= company.task_notify_default_value;
                    });
                } else  {
                    if (data.model.id) {
                        data.model = {};
                    }
                }
                data.model.consumable_asks = [];
            } else if (data.action.id === 'done') {
                if (data.model.equipment_movement_type && data.model.equipment_movement_type === 'come_back') {
                    data.model.equipment_movement_type = 'comeBack';
                }
                data.model.report_hours = data.model.planned_hours;
                service.fetchTaskVehicle(data.model);
                if (data.model.state === 'done') {
                    service.fetchReport(data.model);
                }
            } else if (data.action.id === 'notfinished') {
                data.model.report_hours = data.model.planned_hours;
                data.model.remaining_hours = 2;
            } else if (data.action.id === 'edit') {
                service.fetchTaskVehicle(data.model);
                if (!data.model.consumable_asks) {
                    data.model.consumable_asks = [];
                }
            } else if (data.action.id === 'copy') {
                service.fetchTaskVehicle(data.model);
                if (_.contains(['done', 'cancelled'], data.model.state)) {
                    //should it be draft or open ?
                    data.model.state = 'draft';
                    delete data.model.report_hours;
                }
                // do not duplicate consumable requests or purchase_orders
                data.model.consumable_ask_ids = [];
                data.model.consumable_asks = [];
                data.model.consumable_cost = [];
                data.model.consumable_ids = [];
                data.model.consumable_names = [];

                data.model.purchase_order_ask_fields = [];
                data.model.purchase_order_fields = [];
            }
        };

        service.preModal = function (data) {
            service._preModal(data);
            if(data.action.id === 'attachments') {
                swif.attachment.attachmentPreModal(
                    data,
                    swif.collections.getCollection('tasks')
                );
            }
        };

        service.callbackMessage = function (error, data) {
            if (error) {
                return;
            }
            if (data.action.id === 'add') {
                if (data.action.http.fields) {
                    delete data.action.http.fields;
                }
            }
            swif.collections.defaultCallbackMessage(error, data);
            if (data.action.id === 'notdone') {
                swif.message.addInfo('Task has been unplanned successfully');
            } else  if (data.action.id === 'done' || data.action.id === 'notfinished') {
                swif.message.addInfo('Task has been done successfully');
                if (data.action.id === 'notfinished') {
                    swif.message.addInfo('New task has been created successfully');
                }
            } else if (data.action.id === 'copy') {
                swif.message.addInfo('Task has been copied successfully');
            }
        };

        service.refreshAllCollections = function () {
            return swif.collections.refreshCollections(['tasks']);
        };

        service.collectionCallback = function (collection, data) {
            if (_.contains(['done', 'notdone', 'removefromplanning'], data.action.id)) {
                collection.updateItem(data.model);
            }
            //add item to planning-tasks
            if (_.contains(['add', 'copy'], data.action.id)) {
                data.model.state = 'draft';
            }
            if (data.action.id === 'notfinished') {
                collection.updateItem(data.model);
                collection.getItems();
            }
            if ((data.action.id === 'add' || data.action.id === 'edit') && data.model.recurrence){
                collection.getItems();
                return
            }
            collection.fasterCallback(data);
        };

        service.callback = function (error, data) {
            service.callbackMessage(error, data);
            if (data) {
                var collection = swif.collections.getCollection('tasks');
                if (!collection){
                    collection = swif.collections.getCollection('interventions-tasks');
                }
                if (collection){
                    service.collectionCallback(collection, data);
                }else{
                    swif.collections.refreshCollections(['planning-tasks',
                        'planned-tasks', 'planning-interventions', 'contract-tasks','contract-occurrences']);
                }
            };
        };

        service._computeCollectionFilter = function (user, type) {
            var filter = {};
            user = user || swif.user.getAuthenticatedUserData();
            swif.data.addFilter(filter, 'state', 'in', ['draft', 'open']);
            if (type) {
                if (type === 'publicLightning') {
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'equipment_id.categ_id.is_streetlight',
                        '=',
                        true
                    );
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'project_id.service_id.is_public_lightning',
                        '=',
                        true
                    );
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'project_id.ask_id.is_public_lightning',
                        '=',
                        true
                    );
                }
            } else {
                // the following rights restriction defines a user as a manager
                // so if you want to add extra filters for managers it's right here
                if (_.contains(user.access_rights, 'openstc_tasks_current_partner_view')) {
                    // If Prestataire role, show all tasks associated to his organization
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'partner_id',
                        'in',
                        [user.partner_id[0]]);
                } else if (_.contains(user.access_rights, 'openstc_tasks_survey_service')) {
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'service_id',
                        'in',
                        user.service_ids);
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'team_id.user_ids.id', 'in', [user.id]
                    );
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'team_id.manager_id', '=', user.id                    );
                } else {
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(filter, 'mytasks', '|');
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'user_id',
                        'in',
                        [user.id]
                    );
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'team_id.user_ids.id', 'in', [user.id]
                    );
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'team_id.manager_id', '=', user.id
                    );
                    // if task is assign to one of my services but not to someone
                    swif.data.addExtraFilter(filter, 'mytasks', '&');
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'service_id',
                        'in',
                        user.service_ids
                    );
                    swif.data.addExtraFilter(
                        filter,
                        'mytasks',
                        'user_id',
                        '=',
                        false
                    );
                }
            }
            swif.data.addExtraFilter(filter, 'mytasks', '|');
            swif.data.addExtraFilter(filter, 'mytasks', '|');
            swif.data.addExtraFilter(
                filter,
                'mytasks',
                'project_id', '=', false
            );
            swif.data.addExtraFilter(
                filter,
                'mytasks',
                'project_id.project_type', '!=', 'contract'
            );
            swif.data.addExtraFilter(
                filter,
                'mytasks',
                'parent_ids', '!=', false
            );
            swif.data.sortOn(filter, 'id', 'DESC');
            filter.fields = swif.module.hasModule('opengst_hospital_connector') ?
            [...service.COLLECTION_FIELDS, 'customer_partner_address', 'customer_partner_id']
            : service.COLLECTION_FIELDS;
            return filter;
        };

        service.createCollection = function (type) {
            var filter = service._computeCollectionFilter(undefined, type);
            return swif.collections.createOrUpdate(
                'tasks',
                'task',
                filter,
                {location: true}
            );
        };

        service.syncDateEnd = function (model) {
            var duration = model.planned_hours;
            if (model.effective_hours) {
                duration = model.effective_hours;
            }
            if (model.report_hours) {
                duration = model.report_hours;
            }
            if (model.date_start && duration) {
                model.date_end = swif.date.addHours(
                    model.date_start, duration
                );
            }
            if (!duration && model.date_end) {
                delete model.date_end;
            }
            if (model.date_end) {
                var end = swif.date.getMomentDatetime(model.date_end);
                var now = swif.date.getMomentNow();
                model._shouldBeFinished = end.isBefore(now);
            }
        };

        service.updateUserPartnerAddressFromUser = function (task, userId) {
            var filter = {};
            filter.fields = ['address_id'];
            swif.data.get('user', userId, filter)
                .then(function (user) {
                    task.user_address_id = user.address_id;
                });
        }

        service.updateServiceFromUser = function (task, userid) {
            var filter = {};
            filter.fields = ['service_id', 'service_ids'];
            swif.data.get('user', userid, filter)
                .then(function (user) {
                    var service_id = task.service_id;
                    if (!service_id) {
                        task.service_id = user.service_id;
                    } else if (!_.contains(user.service_ids, service_id[0])) {
                        task.service_id = user.service_id;
                    }
                });
        };

        service.getFilters = function (task, intervention, advanced_mode) {
            var user = swif.user.getAuthenticatedUserData();
            var filters  = {
                intervention: {fields:['id', 'name', 'complete_name']},
                department: {fields:['id', 'name', 'complete_name']},
                task_category: {fields:['id', 'name', 'complete_name']},
                vehicule: {fields:['id', 'name', 'complete_name', 'km', 'equipment_reference']},
                equipments: {fields:['id', 'name', 'complete_name', 'equipment_reference']},
                consumable: {fields:['id', 'name', 'price', 'is_stock', 'warehouse_id', 'product_id', 'default_warehouse_id']},
                suppliers: {fields:['id', 'name', 'complete_name']},
                user_id: {fields:['id', 'name', 'complete_name']},
                team_id: {fields:['id', 'name', 'complete_name']},
                partner_id: {fields:['id', 'name', 'complete_name']},
                partner_address: {fields:['id', 'complete_name', 'email']},
                newagent: {fields:['id', 'name', 'complete_name']},
                tasksRanges: {fields:['id', 'name', 'complete_name']},
                keys_ids: {},
                customer_partner_address: {fields: ['name', 'complete_name', 'partner_id', 'is_active', 'stay_number']},
                customer_partner: {},
            };
            swif.data.addFilter(
                filters.department,
                //                    'technical', '=', true
                'is_assignable_to_task', '=', true
            );

            swif.data.addFilter(filters.newagent, '&')
            swif.data.addFilter(filters.newagent, 'is_assignable_to_task', '=', true)

            // Always include current intervention
            if (intervention && intervention.id) {
                swif.data.addFilter(filters.intervention, '|');
                swif.data.addFilter(
                    filters.intervention,
                    'id', '=', intervention.id
                );
            }

            swif.data.addFilter(
                filters.intervention,
                'state', 'in', ['open', 'scheduled', 'pending']
            );
            swif.data.addFilter(
                filters.vehicule, 'categ_id.is_vehicle', '=', true
            );
            swif.data.addFilter(
                filters.vehicule, 'internal_use', '=', true
            );
            swif.data.addFilter(
                filters.equipments, 'categ_id.is_equipment', '=', true
            );
            swif.data.addFilter(
                filters.equipments, 'internal_use', '=', true
            );
            swif.data.addFilter(
                filters.keys_ids, 'categ_id.is_key', '=', true
            );
            swif.data.addFilter(
                filters.keys_ids, 'internal_use', '=', true
            );
            swif.data.addFilter(
                filters.suppliers, 'supplier', '=', true
            );
            swif.data.addFilter(
                filters.partner_id, 'type_id.service_supplier', '=', true
            );
            swif.data.addFilter(
                filters.user_id, 'is_assignable_to_task', '=', true
            );
            // Tasks ranges - KEEP THIS FILTERS ORDER for filters.tasksRanges
            if (task.service_id) {
                swif.data.addFilter(filters.tasksRanges, '|');
            }
            swif.data.addFilter(
                filters.tasksRanges, 'service_ids', '=', false
            );
            if (task.service_id) {
                swif.data.addFilter(
                    filters.tasksRanges, 'service_ids', 'in', [task.service_id[0]]
                );
            }
            if (task.user_id) {
                swif.data.addFilter(
                    filters.department,
                    'user_authorized_ids', 'in', [task.user_id[0]]
                );
            }
            //add a task outside of an intervention
            if (!task.project_id && !task.id) {
                var user_service_ids = user.service_ids;
                var isUserPartner = _.contains(user.access_rights, 'PRES');
                if (!advanced_mode) {
                    if (!isUserPartner){
                        // Prevent filtering by user allowed service_ids when we're a Partner
                        // else we will lose our current service info
                        swif.data.addFilter(
                            filters.department,
                            'id', 'in', user_service_ids
                        );
                    }
                    swif.data.addFilter(
                        filters.user_id, 'service_ids.id', 'in', user_service_ids // ZARB ↓
                    );
                    swif.data.addFilter(
                        filters.team_id, 'service_ids.id', 'in', user_service_ids // ZARB ↑
                    );
                    swif.data.addFilter(filters.task_category, '|');
                    swif.data.addFilter(
                        filters.task_category,
                        'service_ids', '=', false
                    );
                    swif.data.addFilter(
                        filters.task_category,
                        'service_ids.id', 'in', user_service_ids
                    );
                } else {
                    swif.data.addFilter(
                        filters.user_id, 'service_ids.id', 'child_of', user_service_ids
                    );
                    swif.data.addFilter(
                        filters.team_id, 'service_ids.id', 'child_of', user_service_ids
                    );
                    swif.data.addFilter(filters.task_category, '|');
                    swif.data.addFilter(
                        filters.task_category,
                        'service_ids', '=', false
                    );
                    swif.data.addFilter(
                        filters.task_category,
                        'service_ids.id', 'child_of', user_service_ids
                    );
                }
            }
            if (task.service_id) {
                swif.data.addFilter(
                    filters.consumable, '|'
                );
                swif.data.addFilter(
                    filters.consumable, 'type_id.service_ids', 'in', [task.service_id[0]]
                );
                swif.data.addFilter(
                    filters.consumable, 'type_id.service_ids', '=', false
                );
                swif.data.addFilter(
                    filters.user_id, 'service_ids.id', 'in', [task.service_id[0]]
                );
                swif.data.addFilter(
                    filters.team_id, 'service_ids.id', 'in', [task.service_id[0]]
                );
                swif.data.addFilter(filters.task_category, '|');
                swif.data.addFilter(
                    filters.task_category,
                    'service_ids', '=', false
                );
                swif.data.addFilter(
                    filters.task_category,
                    'service_ids.id', '=', task.service_id[0]
                );
                swif.data.addFilter(
                    filters.vehicule,
                    '|'
                );
                swif.data.addFilter(
                    filters.vehicule,
                    'service_ids', '=?', false
                );
                swif.data.addFilter(
                    filters.vehicule,
                    'service_ids.id', '=', task.service_id[0]
                );
                swif.data.addFilter(
                    filters.equipments,
                    '|'
                );
                swif.data.addFilter(
                    filters.equipments,
                    'service_ids', '=?', false
                );
                swif.data.addFilter(
                    filters.equipments,
                    'service_ids.id', '=', task.service_id[0]
                );
                swif.data.addFilter(
                    filters.keys_ids,
                    '|'
                );
                swif.data.addFilter(
                    filters.keys_ids,
                    'service_ids', '=?', false
                );
                swif.data.addFilter(
                    filters.keys_ids,
                    'service_ids.id', '=', task.service_id[0]
                );
            }
            if (task.customer_partner_id) {
                swif.data.addFilter(
                    filters.customer_partner_address,
                    'partner_id.id', '=', task.customer_partner_id[0]
                );
            }
            if (swif.settings.app.features.equipmentMovement && user.can_manage_equipment_move) {
                delete filters.equipments.domain;
                if (user.equipment_categories_ids.length > 0) {
                    swif.data.addFilter(
                        filters.equipments, 'categ_id', 'in', user.equipment_categories_ids
                    );
                } else {
                    swif.data.addFilter(
                        filters.equipments,
                        'categ_id.is_key', '=', false
                    );
                    swif.data.addFilter(
                        filters.equipments,
                        'categ_id.is_vehicle', '=', false
                    );
                    swif.data.addFilter(
                        filters.equipments,
                        'categ_id.is_fluid_meter', '=', false
                    );
                }
            }
            return filters;
        };

        service.changeDoneState = function (model, isDone) {
            if (model.id !== undefined) {
                return;
            }
            var user = swif.user.getAuthenticatedUserData();
            if (isDone) {
                model.state = 'done';
                if (model.planned_hours) {
                    model.report_hours = model.planned_hours;
                } else {
                    swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                        model.report_hours = company.task_default_report_hours;
                    });
                }
                delete model.planned_hours;
                if (!model.date_start) {
                    model.date_start = swif.date.parseDatetime(new Date());
                }
                if (user.service_id && !model.service_id) {
                    model.service_id = [user.service_id[0], user.service_id[1]];
                }
                if (!model.user_id) {
                    if (model.id) {
                        model.user_id = [user.id, user.complete_name];
                    } else {
                        model.user_id = [user.id];
                    }
                }
            } else {
                model.state = 'open';
                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                    model.planned_hours = company.task_default_hours;
                });
                delete model.report_hours;
            }
        };

        service.getWorks = function (task) {
            var filter = {};
            var task_ids = [];
            var tasks = _.isArray(task) ? task: [task];
            _.forEach(tasks, function (item) {
                if (_.isObject(item)) {
                    task_ids.push(item.id);
                } else if (_.isNumber(item)) {
                    task_ids.push(item);
                }
            });

            swif.data.addFilter(filter, 'task_id', 'in', task_ids);
            return swif.data.get('work', undefined, filter);
        };

        service.getEquipmentLines = function (task) {
            var filter = {};
            var task_ids = [];
            var tasks = _.isArray(task) ? task: [task];
            _.forEach(tasks, function (item) {
                if (_.isObject(item)) {
                    task_ids.push(item.id);
                } else if (_.isNumber(item)) {
                    task_ids.push(item);
                }
            });
            swif.data.addFilter(filter, 'task_id', 'in', task_ids);
            return swif.data.get('equipment_line', undefined, filter);
        };

        service.getConsumedFromWork = function (work) {
            var filter = {};
            var work_id;
            if (_.isObject(work)) {
                work_id = work.id;
            } else if (_.isNumber(work)) {
                work_id = work;
            }
            swif.data.addFilter(filter, 'work_id', '=', work_id);
            return swif.data.get('consumed', undefined, filter);
        };

        service.getConsumedFromTasks = function (task) {
            var filter = {};
            var task_ids = [];
            var tasks = _.isArray(task) ? task: [task];
            _.forEach(tasks, function (item) {
                if (_.isObject(item)) {
                    task_ids.push(item.id);
                } else if (_.isNumber(item)) {
                    task_ids.push(item);
                }
            });

            swif.data.addFilter(filter, 'work_id.task_id', 'in', task_ids);
            return swif.data.get('consumed', undefined, filter);
        };

        service.removeFromPlanning = function (task) {
            task.user_id = false;
            task.team_id = false;
            task.date_start = false;
            task.date_end = false;
            task.partner_id = false;
            task.partner_address = false;
        };

        service.getIntervention = function (task) {
            if (task.project_id) {
                var filter = {};
                filter.fields = ['id', 'name', 'state'];
                return swif.data.get('intervention', task.project_id[0], filter);
            }
        };

        return service;
    }
})();
